module.exports = __webpack_public_path__ + "img/appltCourse-img31.9c4f80e9.png";